// extracted by mini-css-extract-plugin
export default {"button":"EcRKXGas","content":"zuuZH70z","letterSpacing":"_cfPXCN7"};